import Link from "next/link";
import IntlMessages from "../Locale/IntlMessages";
import { GuideIco, MailIco, RocketIco, TipIco, CalendarOutlinedIco, ListLibIco } from "../Icons/IconMenu";
import { DaoTaoIcon, ExamIcon, ReportIcon } from "../Icons/NavbarIcon";

/** Menu Cấu hình Email — phân hệ Quy trình (nhóm Thiết lập). */
export const QuyTrinhCauHinhEmailMenu = {
  key: 'quy-trinh-cau-hinh-email',
  modulename: 'quy-trinh,cauhinh',
  checklicense: false,
  label: <IntlMessages id="bsc.label.cauhinhemail" text="Cấu hình Email" />,
  icon: (
    <span>
      <MailIco />
    </span>
  ),
  children: [
    {
      key: 'quy-trinh-email-logs',
      modulename: 'quy-trinh,cauhinh',
      checklicense: false,
      label: (
        <Link href="/quy-trinh/email-logs">
          <IntlMessages id="bsc.label.nhatkyemail" text="Email Logs" />
        </Link>
      ),
    },
    {
      // Menu Cấu hình Email → Thời gian gửi mail (parity VH). Scheduler đọc CauHinhs.config_thoigian.
      key: 'quy-trinh-thoi-gian-gui-mail',
      modulename: 'quy-trinh,cauhinh,cauhinh_thoigian',
      checklicense: false,
      label: (
        <Link href="/quy-trinh/cau-hinh-email/thoi-gian-gui-mail">
          <IntlMessages id="bsc.label.thoigianguimail" text="Thời gian gửi mail" />
        </Link>
      ),
    },
    {
      key: 'quy-trinh-cau-hinh-smtp',
      modulename: 'quy-trinh,cauhinh',
      checklicense: false,
      label: (
        <Link href="/quy-trinh/cau-hinh-email/cau-hinh-smtp">
          <IntlMessages id="bsc.menu.cau-hinh-smtp" text="Cấu hình SMTP" />
        </Link>
      ),
    },
    {
      key: 'quy-trinh-khoi-phuc-mat-khau',
      modulename: 'quy-trinh,cauhinh',
      checklicense: false,
      label: (
        <Link href="/quy-trinh/cau-hinh-email/mau-mail/khoi-phuc-mat-khau">
          Mail khôi phục mật khẩu
        </Link>
      ),
    },
    {
      key: 'quy-trinh-xac-nhan-khoi-phuc',
      modulename: 'quy-trinh,cauhinh',
      checklicense: false,
      label: (
        <Link href="/quy-trinh/cau-hinh-email/mau-mail/xac-nhan-khoi-phuc">
          Xác nhận khôi phục mật khẩu
        </Link>
      ),
    },
    {
      key: 'quy-trinh-email-template',
      modulename: 'quy-trinh,cauhinh',
      checklicense: false,
      label: <Link href="/quy-trinh/cau-hinh-email/mau-mail">Email Template</Link>,
    },
  ],
};

export const ProcedureStep = {
  key: 'trien-khai-quy-trinh',
  label: <IntlMessages id="bsc.menu.trien-khai-quy-trinh" text="Triển Khai Quy Trình" />,
  type: 'group' as const,
  children: [
    {
      key: 'quy-trinh',
      checklicense: false,
      label: <Link href="/quy-trinh">Master Process</Link>,
      icon: <span><RocketIco /></span>,
    },
    {
      key: 'quy-trinh-sla',
      checklicense: false,
      label: <Link href="/quy-trinh/sla">Quản lý SLA</Link>,
      icon: <span><TipIco /></span>,
    },
    {
      key: 'quy-trinh-sla-calendar',
      checklicense: false,
      label: <Link href="/quy-trinh/sla-calendar">Quản lý lịch làm việc</Link>,
      icon: <span><CalendarOutlinedIco /></span>,
    },
    {
      key: 'task-inbox',
      checklicense: false,
      label: <Link href="/quy-trinh/task-inbox">Hộp thư công việc</Link>,
      icon: <span><MailIco /></span>,
    },
    // Tạm ẩn Monitoring trên FE
    // {
    //   key: 'quy-trinh-dashboard',
    //   checklicense: false,
    //   label: <Link href="/quy-trinh/dashboard">Monitoring</Link>,
    //   icon: <span><ChartIcon /></span>,
    // },
    {
      key: 'quy-trinh-analytics',
      checklicense: false,
      label: <Link href="/quy-trinh/analytics">Phân tích & Báo cáo</Link>,
      icon: <span><ReportIcon /></span>,
    },
    {
      key: 'quy-trinh-exam-question-bank',
      checklicense: false,
      label: <Link href="/quy-trinh/exam-question-bank">Ngân hàng câu hỏi & Đề thi</Link>,
      icon: <span><ListLibIco /></span>,
    },
    {
      key: 'quy-trinh-dao-tao-quy-trinh',
      checklicense: false,
      label: <Link href="/quy-trinh/dao-tao-quy-trinh">Thi Quy Trình</Link>,
      icon: <span><ExamIcon /></span>,
    },

    {
      key: 'quy-trinh-curriculum',
      checklicense: false,
      label: <Link href="/quy-trinh/curriculum">Quản lý giáo trình</Link>,
      icon: <span><DaoTaoIcon /></span>,
    },
    {
      key: 'quy-trinh-curriculum-learn',
      checklicense: false,
      label: <Link href="/quy-trinh/curriculum-learn">Học giáo trình</Link>,
      icon: <span><GuideIco /></span>,
    },
    // Tạm ẩn menu item migrate v1 → v2
    // {
    //   key: 'quy-trinh-legacy-migration',
    //   // modulename riêng, không gán cho role nào — chỉ isAdmin (bypass hasRole) thấy được mục này.
    //   modulename: 'quy-trinh-legacy-migration',
    //   checklicense: false,
    //   label: <Link href="/quy-trinh/legacy-migration">Migrate quy trình v1 → v2</Link>,
    //   icon: <span><DatabaseIcon /></span>,
    // },
  ],
}
